import { useStore } from "../store";
import { MutationTypes } from '../store/mutations';
import { openErrorModal } from "@/composables/useErrorLog";

const ApiService = {
  async getUserInfo(accessToken: string) {
    const store = useStore();
    if (store.state.storeid != '0') {
      return;
    }
    try {
      const response = await fetch(process.env.VUE_APP_AUTH0_USERINFO_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      if (response.status > 400) {
        throw new Error(JSON.stringify(data.error));
      }

      const store = useStore();
      store.commit(MutationTypes.SET_STOREID, data["http://protractor.com/storeid"]);
      store.commit(MutationTypes.SET_ROLE, data["http://protractor.com/role"]);
      store.commit(MutationTypes.SET_ENTERPRISEID, data["http://protractor.com/enterpriseid"]);
      store.commit(MutationTypes.SET_USERNAME, data["email"]);
    } catch (e: unknown) {
      if (e instanceof Error)
        openErrorModal(e.message);
    }
  },

  async getStoreDetails(accessToken: string, storeid: string) {
    try {
      const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "stores/" + storeid, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (response.status > 400) {
        throw new Error(JSON.stringify(data.error));
      }

      const store = useStore();
      store.commit(MutationTypes.SET_STORENAME, data.message.storename);
      store.commit(MutationTypes.SET_STORESTATUS, data.message.storestatus);
      store.commit(MutationTypes.SET_MANAGEDFEATUREIDS, data.message.managedfeatureids);
    } catch (e: unknown) {
      if (e instanceof Error)
        openErrorModal(e.message);
    }
  },

  // Enterprise Name is not included the auth0 userinfo
  async getEnterpriseNameById(accessToken: string, enterpriseid: string) {
    const store = useStore();
    if (store.state.enterprisename != '') // default value is empty string
      return store.state.enterprisename;

    const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "enterprises/" + enterpriseid, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const data = await response.json();
    store.commit(MutationTypes.SET_ENTERPRISENAME, data.message.EnterpriseName);
    return store.state.enterprisename;
  },

  async getEnterpriseStores(accessToken: string, enterpriseid: string) {
    const store = useStore();
    if (store.state.enterprisestores.length > 0)
      return store.state.enterprisestores;

    const response = await fetch(`${process.env.VUE_APP_NODEJS_BASE_URL}enterprises/stores/${enterpriseid}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const data = await response.json();
    const enterprisestores = data.message;
    store.commit(MutationTypes.SET_ENTERPRISESTORES, enterprisestores);
    return store.state.enterprisestores;
  },
};

export default ApiService;